import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-barnehagelan",
  templateUrl: "./barnehagelan.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class BarnehagelanComponent implements OnInit {
  objectKeys = Object.keys;
  statistikkType = "Tilsagn";
  graferValgt = "soknader";
  valgtFilter: { [key: string]: NxCell[] } = null;
  grafIderForSoknad: string[] = [];
  grafIderForBelop: string[] = [];
  grafIderForGjennomsnitt: string[] = [];
  grafIderForPlasser: string[] = [];
  kpiListeForSoknad: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt barnehagelån i perioden som er valgt. "],
      plasser: [
        "Antall barnehageplasser",
        "Viser hvor mange barnehageplasser som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. ",
      ],
      belop: ["Beløp", "Viser lånebeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
      gjennomsnitt: [
        "Gjennomsnittlig prosjektkostnad per plass",
        "Viser gjennomsnittlig prosjektkostnad per plass for valgt periode, og valgt saksbehandlingsstatus (søkt, tilsagn eller utbetalt). Summen av samtlige kostnader for prosjektet. Gjennomsnittlig prosjektkostnad beregnes slik: «Sum prosjektkostnader» delt på «antall plasser» i valgt periode og saksbehandlingsstatus.",
      ],
    },
    Tilsagn: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt barnehagelån i perioden som er valgt. "],
      plasser: [
        "Antall barnehageplasser",
        "Viser hvor mange barnehageplasser som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. ",
      ],
      belop: ["Beløp", "Viser lånebeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
      gjennomsnitt: [
        "Gjennomsnittlig prosjektkostnad per plass",
        "Viser gjennomsnittlig prosjektkostnad per plass for valgt periode, og valgt saksbehandlingsstatus (søkt, tilsagn eller utbetalt). Summen av samtlige kostnader for prosjektet. Gjennomsnittlig prosjektkostnad beregnes slik: «Sum prosjektkostnader» delt på «antall plasser» i valgt periode og saksbehandlingsstatus.",
      ],
    },
    Utbetaling: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt barnehagelån i perioden som er valgt. "],
      plasser: [
        "Antall barnehageplasser",
        "Viser hvor mange barnehageplasser som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt lån i perioden som er valgt. ",
      ],
      belop: ["Beløp", "Viser lånebeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
      gjennomsnitt: [
        "Gjennomsnittlig prosjektkostnad per plass",
        "Viser gjennomsnittlig prosjektkostnad per barnehageplass for valgt periode, og valgt saksbehandlingsstatus (søkt, tilsagn eller utbetalt). Summen av samtlige kostnader for prosjektet. Gjennomsnittlig prosjektkostnad beregnes slik: «Sum prosjektkostnader» delt på «antall plasser» i valgt periode og saksbehandlingsstatus.",
      ],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "BARNEHAGELÅN", false, true);
    this.qlikService.setFilter("TypeTilstand", "Tilsagn", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Lån til barnehager (Historisk ordning) - Husbanken");
    this.grafIderForSoknad = ["hvb-ant-saker-pr-fylke", "hvb-ant-saker", "hvb-ant-saker-pr-tiltak"];
    this.grafIderForBelop = ["hvb-belop-pr-fylke", "hvb-belop", "hvb-belop-pr-tiltak"];
    this.grafIderForGjennomsnitt = ["bhg-gjennomsnitt-beløp-pr-fylke", "bhg-gjennomsnitt-beløp-pr-plass", "bhg-gjennomsnitt-beløp-pr-tiltak"];
    this.grafIderForPlasser = ["bhg-ant-plasser-pr-fylke", "bhg-ant-plasser", "bhg-ant-pr-tiltak"];
    this.kpiListeForSoknad = [
      "HVB Antall saker",
      "BHG Antall barnehageplasser",
      "HVB Beløp",
      "BHG Gjennomsnittlig prosjektkostnad per plass",
      "HVB Gjennomsnittlig prosjektkostnad per tilsagn",
    ];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    if (this.typeTekst[this.statistikkType][this.graferValgt]) {
      return this.typeTekst[this.statistikkType][this.graferValgt][0];
    } else {
      return "Antall saker";
    }
  }
}
